import gql from "graphql-tag"

export const AVAILABLE_PLUGINS_QUERY = gql`
  query availableReportPlugins($siteId: UUID!) {
    availableReportPlugins(siteId: $siteId) {
      id
      vendor
      name
      enabled
      description
    }
  }
`

export const ATTACH_PLUGIN_MUTATION = gql`
  mutation attachPlugin($siteId: UUID!, $vendor: ReportPluginVendor!) {
    attachReportPluginToSite(siteId: $siteId, vendor: $vendor) {
      success
      message
    }
  }
`

export const REMOVE_PLUGIN_MUTATION = gql`
  mutation removePlugin($siteId: UUID!, $vendor: ReportPluginVendor!) {
    removeReportPluginFromSite(siteId: $siteId, vendor: $vendor) {
      success
      message
    }
  }
`

const availableReportPluginFragment = gql`
  fragment availableReportPluginFragment on ReportPlugin {
    id
    enabled
  }
`

export function updateAvailableReportPluginCache(
  reportPluginId,
  enabled,
  dataKey,
  toggle = true
) {
  return (proxy, { data }) => {
    if (!data[dataKey].success) {
      return
    }

    const fragmentInfo = {
      fragment: availableReportPluginFragment,
      id: `ReportPlugin:${reportPluginId}`,
    }

    const plugin = proxy.readFragment(fragmentInfo)

    plugin.enabled = toggle ? !enabled : enabled

    proxy.writeFragment({
      ...fragmentInfo,
      data: plugin,
    })
  }
}

export function updatePluginSetup(options) {
  let {
    siteId,
    id,
    enabled,
    vendor,
    attachPluginMutate,
    removePluginMutate,
    trackButtonClicked,
    isSubmitting,
    setIsSubmitting,
    availablePlugins,
    setError,
  } = options
  let toggle = true

  let mutationVariant = enabled ? removePluginMutate : attachPluginMutate
  let dataKeyVariant = enabled
    ? `removeReportPluginFromSite`
    : `attachReportPluginToSite`

  // remove Lighthouse plugin if buildsEnabled changes to false
  if (!options.id) {
    const lighthousePlugin = availablePlugins.find(
      item => item.name === `Lighthouse`
    )

    id = lighthousePlugin && lighthousePlugin.id

    if (!id || !lighthousePlugin.enabled) {
      return null
    }

    enabled = false
    vendor = "LIGHTHOUSE"
    toggle = false
    mutationVariant = removePluginMutate
    dataKeyVariant = `removeReportPluginFromSite`
  }

  setIsSubmitting({
    ...isSubmitting,
    [id]: true,
  })

  trackButtonClicked(`update report plugin`, {
    uiSource: `Site Settings`,
  })

  mutationVariant({
    variables: {
      siteId,
      vendor,
    },
    update: updateAvailableReportPluginCache(
      id,
      enabled,
      dataKeyVariant,
      toggle
    ),
    optimisticResponse: {
      [dataKeyVariant]: {
        success: true,
        message: null,
        __typename: `MutationResult`,
      },
    },
  })
    .then(({ data }) => {
      if (data[dataKeyVariant].success) {
        setIsSubmitting({
          ...isSubmitting,
          [id]: false,
        })
      }
    })
    .catch(err => {
      setIsSubmitting({
        ...isSubmitting,
        [id]: false,
      })
      setError(err)
    })
}
